import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface F908 {
  f908_01: string;         // 假別代號 (PK, 1 char)
  f908_10: number;         // 假別類別
  f908_11: string;         // 假別名稱
  f908_12: number;         // 計算單位
  f908_13: number;         // 每次最低數
  f908_14: number;         // 每次最高數
  f908_15: number;         // 每年可用數
  f908_16: number;         // 扣薪比率(%)
  f908_17: number;         // 是否經人事審核
  f908_21: number;         // 初核最高單位數
  f908_22: boolean;        // 包含例假日
  f908_23: boolean;        // 不計算上班時數
  f908_91: string;         // 建立人員
  f908_92: string | null;  // 建立/修改日期
  f908_93: string;         // 修改人員
}

export interface CreateRequest {
  f908_01: string;
  f908_10: number;
  f908_11: string;
  f908_12: number;
  f908_13: number;
  f908_14: number;
  f908_15: number;
  f908_16: number;
  f908_17: number;
  f908_21: number;
  f908_22: boolean;
  f908_23: boolean;
}

export interface UpdateRequest {
  f908_10: number;
  f908_12: number;
  f908_13: number;
  f908_14: number;
  f908_15: number;
  f908_16: number;
  f908_17: number;
  f908_21: number;
  f908_22: boolean;
  f908_23: boolean;
}

export interface ListResponse {
  data: F908[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const leaveTypeApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/leave-type', { params });
    return res.data;
  },

  async get(code: string): Promise<F908> {
    const res = await apiClient.get(`/api/leave-type/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F908> {
    const res = await apiClient.post('/api/leave-type', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<F908> {
    const res = await apiClient.put(`/api/leave-type/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/leave-type/${encodeURIComponent(code)}`);
  },
};
